window.YaMap = {
	placeMarkMain: '<div class="vg-map-marker color-main"><div class="pin bounce"></div><div class="pulse"></div></div>',

	pointsMap: function () {
		ymaps.ready(init);

		var myMap;

		function init() {

			var init = initMap();
			if (!init) return false;

			myMap = new ymaps.Map(map, {
				center: [init.lat, init.lon],
				zoom: init.zoom,
				controls: ['smallMapDefaultSet'],
			});

			myMap.behaviors.disable('scrollZoom');

			myMap.events.add('click', function (e) {
				hidePanel(map);
			});

			myMap.controls.remove('geolocationControl');
			myMap.controls.remove('searchControl');
			myMap.controls.remove('typeSelector');
			myMap.controls.remove('fullscreenControl');

			myCollection = new ymaps.GeoObjectCollection({}, {});

			placeMarkData(myCollection, map, [init.lat, init.lon]);
			openPanel(map, init.id);

			myMap.geoObjects.add(myCollection);

			function placeMarkData(collection, map, coordinate) {
				var placemark = new ymaps.Placemark(coordinate, {
						'langlon': coordinate
					},
					{
						preset: 'islands#dotIcon',
						iconColor: '#d46868',
					});

				collection.add(placemark);

				placemark.events.add('click', function (event) {
					openPanel(map, $(this).data('id'));
				});
			}

			$(document).on('click', '.closePanel', function () {
				hidePanel(map);
			});

			$('.getMapPlace-' + map).click(function () {
				var $self = $(this);

				$self.closest('.points').find('.point').removeClass('active');
				$self.addClass('active');

				placeMarkData(myCollection, map, [$self.data('lat'), $self.data('lon')]);

				myMap.setCenter(
					[$self.data('lat'), $self.data('lon')], 17
				);

				openPanel(map, $self.data('id'));

				return false;
			});

			function initMap() {
				var $point = $('.tab-pane.active').find('.point.active');

				return {
					lat: $point.data('lat'),
					lon: $point.data('lon'),
					id: $point.data('id'),
					zoom: 16
				};
			}

			function hidePanel(map) {
				$('.info-panel-' + map).removeClass('right');
			}

			function openPanel(map, id) {
				var $panel = $('.info-panel-' + map);
				var params = {
					id: id,
					type: map
				};

				$.get('/location/getPoints', params, function (data) {
					$panel.addClass('right');
					$panel.html(data.view);
				});
			}
		}
	},

	mapDelivery: function () {
		// Courier & PostMail
		let container = 'getMapAddress', $searchInput = $('.' + container);

		if ($searchInput.length) {
			$searchInput.each(function () {
				let $s_self = $(this),
					map = $s_self.data('map'),
					id = $s_self.attr('id');

				setTimeout(function () {
					ymaps.ready(searchApi);
				}, 1000);


				function searchApi() {
					let myMap, myPlacemark, coords;

					ymaps.geocode(GeoLocation.getCity(), {
						results: 1
					}).then(function (res) {
						var firstGeoObject = res.geoObjects.get(0);
						coords = firstGeoObject.geometry.getCoordinates();

						drawMap(coords);
					});

					function drawMap(coordinates) {
						myMap = new ymaps.Map(map, {
							center: coordinates,
							zoom: 17,
							controls: ['zoomControl', 'fullscreenControl']
						}, {searchControlProvider: 'yandex#search'});

						myMap.events.add('click', function (e) {
							var coords = e.get('coords');

							if (myPlacemark) {
								myPlacemark.geometry.setCoordinates(coords);
							} else {
								myPlacemark = createPlacemark(coords);
								myMap.geoObjects.add(myPlacemark);
								myPlacemark.events.add('dragend', function () {
									getAddress(myPlacemark.geometry.getCoordinates());
								});
							}
							getAddress(coords);
							myMap.panTo(coords, {
								checkZoomRange: true
							});
						});

						function createPlacemark(coords) {
							var circleLayout = ymaps.templateLayoutFactory.createClass(YaMap.placeMarkMain);

							return new ymaps.Placemark(coords, {
								iconCaption: 'Подождите...'
							}, {
								iconLayout: circleLayout,
								draggable: true,
							});
						}

						function getAddress(coords) {
							myPlacemark.properties.set('iconCaption', 'Подождите...');
							ymaps.geocode(coords).then(function (res) {
								var firstGeoObject = res.geoObjects.get(0);

								myPlacemark.properties
									.set({
										iconCaption: [
											firstGeoObject.getLocalities().length ? firstGeoObject.getLocalities() : firstGeoObject.getAdministrativeAreas(),
											firstGeoObject.getThoroughfare() || firstGeoObject.getPremise()
										].filter(Boolean).join(', '),
										balloonContent: firstGeoObject.getAddressLine()
									});

								$s_self.val(firstGeoObject.getAddressLine());
							});
						}

						myMap.geoObjects.events.add('click', function (e) {
							var object = e.get('target');
							myMap.geoObjects.remove(object);
							myPlacemark = null;
						});

						$s_self.keyup(function (e) {
							if (e.keyCode === 13) {
								ymaps.geocode(document.getElementById(id).value, {results: 1}).then(function (res) {
									var firstGeoObject = res.geoObjects.get(0),
										coords = firstGeoObject.geometry.getCoordinates();
									if (myPlacemark) {
										myPlacemark.geometry.setCoordinates(coords);
									} else {
										myPlacemark = createPlacemark(coords);
										myMap.geoObjects.add(myPlacemark);
										myPlacemark.events.add('dragend', function () {
											getAddress(myPlacemark.geometry.getCoordinates());
										});
									}

									myMap.geoObjects.add(myPlacemark);
									getAddress(coords);
									myMap.panTo(coords, {
										checkZoomRange: true
									});
								});

								e.preventDefault();
								return false;
							}
						});

						var suggestView = new ymaps.SuggestView(id);
						suggestView.events.add('select', function (e) {
							ymaps.geocode(e.get('item').value, {results: 1}).then(function (res) {
								var firstGeoObject = res.geoObjects.get(0),
									coords = firstGeoObject.geometry.getCoordinates();
								if (myPlacemark) {
									myPlacemark.geometry.setCoordinates(coords);
								} else {
									myPlacemark = createPlacemark(coords);
									myMap.geoObjects.add(myPlacemark);
									myPlacemark.events.add('dragend', function () {
										getAddress(myPlacemark.geometry.getCoordinates());
									});
								}

								myMap.geoObjects.add(myPlacemark);
								getAddress(coords);
								myMap.panTo(coords, {
									checkZoomRange: true
								});
							});
						});

						myMap.behaviors.disable('scrollZoom');
					}
				}
			});
		}

		// Pickup
		if ($('#yaMapStores').length) {
			let yaMapStores;

			setTimeout(function () {
				ymaps.ready(init);
			}, 1000);

			function init() {
				let $addresses = $('.vg-shop-order__address').find('input[type=radio]'),
					$container = $addresses.closest('li'),
					$first_address = $container.find('input:checked');

				yaMapStores = new ymaps.Map('yaMapStores', {
					center: [$first_address.data('lat'), $first_address.data('lon')],
					zoom: 17,
					controls: ['smallMapDefaultSet'],
				});

				//yaMapStores.behaviors.disable('scrollZoom');
				yaMapStores.controls.remove('geolocationControl');
				yaMapStores.controls.remove('searchControl');
				yaMapStores.controls.remove('typeSelector');
				yaMapStores.controls.remove('fullscreenControl');

				YaMap.addMarker(yaMapStores, $addresses, YaMap.placeMarkMain);

				$('.store-radio-address').change(function () {
					let $self = $(this),
						lat = $self.data('lat'),
						lon = $self.data('lon');

					yaMapStores.setCenter([lat, lon], 17);
					return true;
				});

				if (window.innerWidth < 768) {
					yaMapStores.behaviors.disable('drag');
				}
			}
		}
	},

	mapStores: function (store = null) {
		if (store === null) {
			let $store = $('#yaMapStore');

			if ($store.length) {
				ymaps.ready(init);

				function init() {
					var myMap = new ymaps.Map('yaMapStore', {
						center: [$store.data('lat'), $store.data('lon')],
						zoom: 16
					}, {
						searchControlProvider: 'yandex#search'
					});

					YaMap.addMarker(myMap, null, YaMap.placeMarkMain);
				}
			}
		} else {
			function init() {
				var myMap = new ymaps.Map('yaMapStoreModal', {
					center: [55.750625, 37.626],
					zoom: 7
				});

				myMap.controls.add('routePanelControl');
				myMap.controls.add('routePanelControl', {
					maxWidth: 400
				});

				var routePanel = myMap.controls.get('routePanelControl').routePanel;
				routePanel.options.set('adjustMapMargin', true);
				routePanel.geolocate('to');
				routePanel.state.set({
					fromEnabled: false,
					from: store['city'] + ', ' + store['address'] + ', магазин Vandersex',
					type: "auto"
				});
			}

			ymaps.ready(init);
		}
	},

	mapAllPointsPickups: function () {
		let mapAllPoints, mapID;

		if (!$('#mapAllPointsPickups').length && !$('#mapCityAllPointsPickup').length) {
			return false
		}

		if (typeof mapAllPointsPickups === 'undefined' && typeof mapCityAllPointsPickup === 'undefined') {
			return false
		} else if (typeof mapAllPointsPickups !== 'undefined') {
			mapAllPoints = mapAllPointsPickups;
			mapID = 'mapAllPointsPickups';
		} else {
			mapAllPoints = mapCityAllPointsPickup;
			mapID = 'mapCityAllPointsPickup';
		}

		var myMap;
		var clusterer;
		var groups = {
			cdek: {index: 2, selected: true},
			pickpoint: {index: 1, selected: true},
			store: {index: -1, selected: true},
		};

		ymaps.ready(init);

		function init() {
			myMap = new ymaps.Map(mapID, {
				center: [55.121946, 99.164798],
				zoom: 10
			}, {
				searchControlProvider: 'yandex#search'
			});

			clusterer = new ymaps.Clusterer({
				clusterIconLayout: 'default#pieChart',
				clusterIconPieChartRadius: 25,
				clusterIconPieChartCoreRadius: 15,
				clusterIconPieChartStrokeWidth: 3,
				hasBalloon: false,
				clusterHideIconOnBalloonOpen: false,
				geoObjectHideIconOnBalloonOpen: false,
			});

			// CDEK
			var cdek = new ymaps.control.Button({
				data: {
					content: "СДЭК",
					image: '/assets/_frontend/images/icons/pickup/cdek-icon.png'
				},
				options: {
					float: 'right',
					maxWidth: [28, 150, 178],
				}
			});
			myMap.controls.add(cdek);
			cdek.select();
			cdek.events.add('click', function (e) {
				clusterer.removeAll();
				groups.cdek.selected = !cdek._selected;
				clusterer.add(getSelectedObjects());
				myMap.geoObjects.add(clusterer);
			});

			// PICKPOINT
			var pickpoint = new ymaps.control.Button({
				data: {
					content: "PickPoint",
					image: '/assets/_frontend/images/icons/pickup/pick_icon.png'
				},
				options: {
					float: 'right',
					maxWidth: [28, 150, 178],
				}
			});
			myMap.controls.add(pickpoint);
			pickpoint.select();
			pickpoint.events.add('click', function (e) {
				clusterer.removeAll();
				groups.pickpoint.selected = !pickpoint._selected;
				clusterer.add(getSelectedObjects());
				myMap.geoObjects.add(clusterer);
			});

			// STORE
			var store = new ymaps.control.Button({
				data: {
					content: "Магазины",
				},
				options: {
					float: 'right',
					maxWidth: [28, 150, 178],
				}
			});
			myMap.controls.add(store);
			store.select();
			store.events.add('click', function (e) {
				clusterer.removeAll();
				groups.store.selected = !store._selected;
				clusterer.add(getSelectedObjects());
				myMap.geoObjects.add(clusterer);
			});

			// ADD ALL OBJECTS
			clusterer.add(getSelectedObjects());
			myMap.geoObjects.add(clusterer);
			myMap.setBounds(myMap.geoObjects.getBounds());

			myMap.controls.remove('typeSelector');
			myMap.controls.remove('routeButtonControl');
			myMap.controls.remove('trafficControl');
			//myMap.behaviors.disable('scrollZoom');
		}

		function getSelectedObjects() {
			let x = 0;
			let objects = [];

			for (let groupName in groups) {
				if (!groups[groupName].selected) continue;
				let group = groups[groupName].index;
				for (let n in mapAllPoints[group].marks) {
					objects[x] = mark(mapAllPoints[group], mapAllPoints[group].marks[n]);
					x++;
				}
			}

			return objects;
		}

		function mark(point, mark) {
			let ypoint = new ymaps.Placemark(mark.coordinates, {},
				{
					iconLayout: 'default#image',
					iconColor: point.color,
					iconImageHref: point.icon,
					iconImageSize: [30, 40]
				});

			ypoint.events.add('click', function (event) {
				let target = '#modalYaMapPoint',
					title = mark.address,
					description = mark.description,
					worktime = mark.worktime;

				let body = '<div class="text">' + description + '</div>' +
					'<div class="worktime">' + worktime + '</div>';

				$(target).find('.modal-title').text(title);
				$(target).find('.modal-body').html(body);

				$(target).modal('show');
			});

			return ypoint;
		}

		$(document).on('click', '.to-map', function () {
			var lat = $(this).data('lat');
			var lon = $(this).data('lon');

			myMap.setCenter([lat, lon], 19);

			$([document.documentElement, document.body]).animate({
				scrollTop: $("#" + mapID).offset().top - 100
			}, 500);

			return false;
		});
	},

	addMarker: function (map, $markers, placeMarkDraw) {
		let circleLayout = ymaps.templateLayoutFactory.createClass(placeMarkDraw);

		if ($markers !== null) {
			$markers.each(function () {
				let placeMark = new ymaps.Placemark([$(this).attr('data-lat'), $(this).attr('data-lon')], {}, {
					iconLayout: circleLayout,
				});

				map.geoObjects.add(placeMark);
			});
		} else {
			let placeMark = new ymaps.Placemark(
				map.getCenter(), {}, {
					iconLayout: circleLayout
				}
			);
			map.geoObjects.add(placeMark);
		}

		return map;
	}
};